import initialState from './initialState'
import {
    SET_WRAPPER_ORIGIN,
    SET_WRAPPER_DEVICE_TYPE,
    SET_WRAPPER_RECIPE_SCHEMA_ITEMS,
    SET_WRAPPER_CURRENT_URL
} from '../constants/actionTypes'


export default (state = initialState, action) => {
    switch (action.type) {
        case SET_WRAPPER_ORIGIN:
            return {
                ...state,
                origin: action.origin
            }

        case SET_WRAPPER_DEVICE_TYPE:
            return {
                ...state,
                deviceType: action.deviceType
            }

        case SET_WRAPPER_RECIPE_SCHEMA_ITEMS:
            return {
                ...state,
                recipeSchemaItems: action.data
            }

        case SET_WRAPPER_CURRENT_URL:
            return {
                ...state,
                currentUrl: action.currentUrl
            }

        default:
            return state
    }
}
